import PropTypes from "prop-types";
import classnames from "classnames";
import KycDocumentRow from "./kyc-document-row";
import SectionCard from "./section-card";

const KycDocumentsCard = ({ docs, submittedCount, requiredCount }) => (
    <SectionCard
        title="Documents"
        action={(
            <span className={classnames("text-xs", submittedCount < requiredCount ? "font-medium text-warning" : "text-muted")}>
                {submittedCount} of {requiredCount} required submitted
            </span>
        )}>
        <ul className="-my-1 divide-y divide-gray-200">
            {docs.map((doc) => <KycDocumentRow key={doc.key} doc={doc} />)}
        </ul>
    </SectionCard>
);

KycDocumentsCard.propTypes = {
    docs          : PropTypes.arrayOf(PropTypes.object).isRequired,
    submittedCount: PropTypes.number.isRequired,
    requiredCount : PropTypes.number.isRequired
};

export default KycDocumentsCard;
